import React, { Component } from 'react'
import classnames from 'classnames'
import CollectionRows from './collection-rows'
import Logo from '../logo'
import BackgroundCanvas from '../background-canvas'
import OverlayHeading from '../overlay-heading'
import CollectionGridList from './collection-grid-list'
import './collection-list.css'

export default class CollectionList extends Component {

  componentDidUpdate(prevProps) {
    const {
      viewMode: prevViewMode
    } = prevProps
    const {
      active: nextActive,
      viewMode: nextViewMode
    } = this.props

    const { pageName, vh } = this.props

    if (nextActive && prevViewMode !== nextViewMode) {

      if (nextViewMode) {
        // switched to grid mode.
        // what is our scroll position ?
        const {
          setElementScroll
        } = this.props
        if (setElementScroll) {
          const targetScrollTop = pageName === 'HOME' ? vh : 0
          setElementScroll(targetScrollTop)
        }

      } else {
        // switched to view mode
        // is there a saved scroll st?
        const {
          setElementScroll
        } = this.props

        if (setElementScroll) {
          const altTargetScrollTop = pageName === 'HOME' ? vh : 0
          setElementScroll(altTargetScrollTop)
        }
      }
    }
  }

  renderGrid() {
    return <CollectionGridList {...this.props} />
  }

  renderRows() {
    return <CollectionRows {...this.props} />
  }

  render() {
    const { 
      colours,
      active,
      logo,
      title,
      subtitle,
      pageName,
      viewMode,
      disableToggle,
      vh,
    } = this.props 

    const isOverlayPage = pageName !== 'HOME'
    const isCollectionPage = title && subtitle

    const collectionListClassNames = classnames({
      'collection__list--lightbox': isCollectionPage,
      'collection__list--grid': (viewMode && !disableToggle)
    }, 'collection__list')
    
    return (
      <div className="collection__list-outer">
        <div className={collectionListClassNames}>
          <BackgroundCanvas active={active} colours={colours}>
            <OverlayHeading vh={vh} disabled={!isOverlayPage} active={!!active} title={subtitle} subtitle={title} />
          </BackgroundCanvas>
          {logo && <Logo animate={true} active={active} />} 
          {(viewMode) ? this.renderGrid() : this.renderRows()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/collection-list/collection-list.js